import React, { useState, useEffect, useMemo } from "react";
import { useTable, useGlobalFilter, usePagination } from "react-table";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import debounce from "lodash.debounce";
import { clearRedemption, getRedemption } from "../../../actions/redemption";

const Paginated = ({
  columns,
  data,
  Redemption,
  getRedemption,
  clearRedemption,
  loader,
  setLoader,
}) => {
  const [selectPage, setSelectPage] = useState();
  const [selectedPageIndex, setSelectedPageIndex] = useState(1);
  const [pageArray, setPageArray] = useState();
  const [transactionCount, setTransactionCount] = useState();

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    page,
    /* nextPage, previousPage, canPreviousPage, canNextPage, pageOptions,gotoPage,*/ state,
    setPageSize,
    prepareRow,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 50 },
    },
    useGlobalFilter,
    usePagination,
  );

  const { globalFilter, /* pageIndex,*/ pageSize } = state;
  const [inputField, setInputField] = useState(globalFilter);
  const [visibleRowCount, setVisibleRowCount] = useState(pageSize);
  const [tempValue, setTempValue] = useState("");

  // useEffect(() => {
  //     if (!rows.length && tempValue) {
  //         const token = JSON.parse(localStorage.getItem("token_gen"));
  //         searchTransaction(token?.access_token, tempValue);
  //     }
  // }, [tempValue]); // eslint-disable-line

  const handleInputChange = (e) => {
    const value = e.target.value;
    setTempValue(value);
    setGlobalFilter(value);
    if (value === "") {
      const token = JSON.parse(localStorage.getItem("token_gen"));
      let tempPageIndex = JSON.parse(localStorage.getItem("CusPageIndex"));
      let id = localStorage.getItem("Id");
      getRedemption(token?.access_token, tempPageIndex, 50);
    }
  };
  const debouncedResults = useMemo((e) => {
    return debounce(handleInputChange, 50);
  }, []); // eslint-disable-line

  useEffect(() => {
    setGlobalFilter(inputField);
  }, [inputField]); // eslint-disable-line

  useEffect(() => {
    setTransactionCount(Redemption.data.totalCount);
  }, [Redemption]); // eslint-disable-line

  useEffect(() => {
    if (transactionCount) {
      let tempTransactionCount = transactionCount / 50;
      let temp = Math.ceil(tempTransactionCount);
      setSelectPage(temp);
    } else {
      setSelectPage(0);
    }
  }, [transactionCount]);

  useEffect(() => {
    let tempPageIndex = JSON.parse(localStorage.getItem("TransPageIndex"));
    if (tempPageIndex !== 1) {
      fetch();
    }
  }, []); // eslint-disable-line

  useEffect(() => {
    const temp = Array.from({ length: selectPage }, (_, index) => index + 1);
    setPageArray(temp);
  }, [selectPage]);

  useEffect(() => {
    let tempPageIndex = JSON.parse(localStorage.getItem("TransPageIndex"));
    tempPageIndex
      ? setSelectedPageIndex(tempPageIndex)
      : setSelectedPageIndex(1);
  }, []);

  const handlePageIndex = (event) => {
    if (event.target.value !== "") {
      const number = Number(event.target.value);
      setSelectedPageIndex(number);
      localStorage.setItem("TransPageIndex", JSON.stringify(number));
      fetch();
      // gotoPage(number);
    }
  };

  const fetch = async () => {
    setLoader(true);
    await clearRedemption();
    let tempPageIndex = JSON.parse(localStorage.getItem("TransPageIndex"));
    const token = JSON.parse(localStorage.getItem("token_gen"));
    let id = localStorage.getItem("Id");
    await getRedemption(token?.access_token, tempPageIndex, 50);
    setLoader(false);
  };

  const handleNext = () => {
    if (selectedPageIndex < pageArray?.length) {
      setSelectedPageIndex(selectedPageIndex + 1);
      localStorage.setItem(
        "TransPageIndex",
        JSON.stringify(selectedPageIndex + 1),
      );
      fetch();
      // nextPage();
    }
  };
  const handlePrevious = () => {
    if (selectedPageIndex > 1) {
      setSelectedPageIndex(selectedPageIndex - 1);
      localStorage.setItem(
        "TransPageIndex",
        JSON.stringify(selectedPageIndex - 1),
      );
      fetch();
      // previousPage();
    }
  };

  return (
    <>
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}

      <div className="customTable">
        <div className="customTable__header">
          <div className="customTable__left"></div>
          {/* <div className="customTable__right">{memoGlobleFilter}</div> */}
        </div>
        <div className="customTable__body">
          <div className="table-responsive">
            {data?.length ? (
              <InfiniteScroll
                dataLength={visibleRowCount}
                next={() => {
                  setVisibleRowCount((prevRowCount) => prevRowCount + pageSize);
                }}
                hasMore={visibleRowCount < rows.length}
              >
                <table
                  className="table table-striped table-bordered sticky_table"
                  {...getTableProps()}
                >
                  <thead>
                    {headerGroups.map((headerGroup) => {
                      const { key, ...headerGroupProps } =
                        headerGroup.getHeaderGroupProps();
                      return (
                        <tr key={key} {...headerGroupProps}>
                          {headerGroup.headers.map((column) => {
                            const { key, ...headerProps } =
                              column.getHeaderProps();
                            return (
                              <th key={key} {...headerProps}>
                                {column.render("Header")}
                              </th>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </thead>

                  <tbody {...getTableBodyProps()}>
                    {rows.slice(0, visibleRowCount).map((row) => {
                      prepareRow(row);
                      const { key, ...rowProps } = row.getRowProps();
                      return (
                        <tr key={key} {...rowProps}>
                          {row.cells.map((cell) => {
                            const { key, ...cellProps } = cell.getCellProps();
                            return (
                              <td key={key} {...cellProps}>
                                {cell.render("Cell")
                                  ? cell.render("Cell")
                                  : "Null"}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </InfiniteScroll>
            ) : (
              <table
                className="table table-striped table-bordered sticky_table"
                {...getTableProps()}
              >
                <thead>
                  {headerGroups.map((headerGroup) => {
                    const { key, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr key={key} {...headerGroupProps}>
                        {headerGroup.headers.map((column) => {
                          const { key, ...headerProps } =
                            column.getHeaderProps();
                          return (
                            <th key={key} {...headerProps}>
                              {column.render("Header")}
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
                <tbody>
                  <tr>
                    <td
                      colSpan={12}
                      style={{
                        textAlign: "center",
                        display: "table-cell",
                        textTransform: "Capitalize",
                      }}
                    >
                      No data found
                    </td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>
        </div>
        <div className="customTable__footer">
          <div className="customTable__left">
            <div className="customTable__totalTransactions">
              <p>
                Total Records: <span>{data?.length}</span>
              </p>
            </div>
          </div>
          <div className="customTable__right">
            <div className="customTable__top">
              <div className="customTable__totalPages">
                {pageArray && (
                  <p>
                    Page
                    <select
                      className="form-control selectArrow"
                      value={selectedPageIndex}
                      onChange={handlePageIndex}
                    >
                      {pageArray.length ? (
                        pageArray.map((value) => (
                          <option key={value} value={value}>
                            {value}
                          </option>
                        ))
                      ) : (
                        <option key={1} value={1}>
                          {1}
                        </option>
                      )}
                    </select>
                    of
                    {pageArray?.length ? (
                      <span>{pageArray?.length}</span>
                    ) : (
                      <span>{1}</span>
                    )}
                  </p>
                )}
              </div>
            </div>
            <div className="customTable__bottom">
              <div className="customTable__buttons">
                <span
                  className="btn btn-outline-primary"
                  onClick={() => handlePrevious()}
                  disabled={selectedPageIndex > 1 ? false : true}
                >
                  {"Previous"}
                </span>
                <span
                  className="btn btn-outline-primary"
                  onClick={handleNext}
                  disabled={
                    pageArray?.length > 0
                      ? selectedPageIndex === pageArray?.length
                        ? true
                        : false
                      : true
                  }
                >
                  {"Next"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  Redemption: state.Redemption,
});
const mapDispatchToProps = {
  getRedemption,
  clearRedemption,
};

export default connect(mapStateToProps, mapDispatchToProps)(Paginated);
